import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { ReportPopupComponent } from './report-popup.component';

@NgModule({
  declarations: [
    ReportPopupComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule
  ],
  entryComponents: [
    ReportPopupComponent   
  ],
  exports: [
    ReportPopupComponent
  ]
})
export class ReportPopupModule { }